export const FILTERS_REPORTING = {
    campaign: {
        filter: 'byCampaign',
        column: 'campaign',
        key: 'campaigns',
    },
    vendor: {
        filter: 'byVendor',
        column: 'vendor',
        key: 'vendors',
    },
    number: {
        filter: 'byNumber',
        column: 'number',
        key: 'numbers',
    },
    phoneNumberPool: {
        filter: 'byPhoneNumberPool',
        column: 'phoneNumberPool',
        key: 'phoneNumberPool',
    },
    replacementNumber: {
        filter: 'byReplacementNumber',
        column: 'replacementNumber',
        key: 'replacementNumber',
    },
    callers: {
        filter: 'callers',
        column: 'callers',
        key: 'callers',
    },
    destinationName: {
        filter: 'byDestination',
        column: 'destinationName',
        key: 'destinationName',
    },
    destinationNumber: {
        filter: 'byDestination',
        column: 'destinationNumber',
        key: 'destinationNumber',
    },
    buyer: {
        filter: 'byBuyer',
        column: 'buyer',
        key: 'buyers',
    },
    trafficSource: {
        filter: 'byTrafficSource',
        column: 'trafficSource',
        key: 'trafficSources',
    },
    parameters: {
        filter: 'byParameters',
        column: 'parameters',
        key: 'parameters',
    },
    callerProfile: {
        filter: 'byCallerProfile',
        column: 'callerProfile',
        key: 'callerProfile',
    },
    callerIdentity: {
        filter: 'byCallerIdentity',
        column: 'callerIdentity',
        key: 'callerIdentity',
    },
    sessionData: {
        filter: 'bySessionData',
        column: 'sessionData',
        key: 'sessionData',
    },
    sipHeaders: {
        filter: 'sipHeaderParameters',
        column: 'sipHeaderParameters',
        key: 'sipHeaderParameters',
    },
    customParameters: {
        filter: 'byCustomParameters',
        column: 'customParameters',
        key: 'customParameters',
    },
    duration: {
        filter: 'byDuration',
        column: 'duration',
        key: 'duration',
    },
    failReason: {
        filter: 'byFailReason',
        column: 'failReason',
        key: 'failReason',
    },
    status: {
        filter: 'byStatus',
        column: 'status',
        key: 'status',
    },
    uuid: {
        key: 'uuid',
    },
    tags: {
        filter: 'byTags',
        column: 'tags',
        key: 'tags',
    },
    dupe: {
        column: 'dupe',
    },
    duplicateRevenue: {
        column: 'duplicateRevenue',
    },
    revenue: {
        column: 'revenue',
    },
    payout: {
        column: 'payout',
    },
    incoming: {
        column: 'incoming',
    },
    live: {
        column: 'live',
    },
    connected: {
        column: 'connected',
    },
    converted: {
        column: 'converted',
    },
    qualified: {
        column: 'qualified',
    },
    paid: {
        column: 'paid',
    },
    noConnect: {
        column: 'noConnect',
    },
    conversionRate: {
        column: 'conversionRate',
    },
    byDate: {
        filter: 'byDate',
    },
    // byReplacementNumber: {
    //     filter: 'byReplacementNumber',
    // },
}
